import moment from 'moment-timezone';

export class DateTimeUtils {
  constructor() {}

  public static getCurrentDateTimeFormattedForApi() {
    return moment().utc().format();
  }

  public static formatDateTimeForDisplay(date: string) {
    return moment(date).format('M/D/YYYY h:mm A');
  }

  public static convertMonthNameToNumber(monthName: string) {
    const monthNumber = moment(monthName, 'MMMM').month() + 1;
    if (isNaN(monthNumber)) {
      throw new Error(`Invalid month name: ${monthName}`);
    }
    return monthNumber;
  }

  public static getCurrentMonthNumber() {
    const date = new Date();
    const month = date.getMonth() + 1; // getMonth() returns 0-11, so add 1
    return month;
  }

  public static getCurrentYear() {
    const date = new Date();
    const year = date.getFullYear();
    return year;
  }
}
